import * as wagmiChains from 'wagmi/chains';
import { type Chain as WagmiChain } from 'wagmi/chains';
import { type ChainData, type ChainflipChainData } from '.';

export const bitcoinTestnet = {
  id: 'btc-testnet',
  name: 'Bitcoin Testnet',
  addressPlaceholder: '',
  wagmiChain: undefined,
  chainflipId: 'Bitcoin',
} satisfies ChainflipChainData;

export const solanaDevnet = {
  id: 'sol-devnet',
  name: 'Solana Devnet',
  addressPlaceholder: '',
  wagmiChain: undefined,
  chainflipId: 'Solana',
} satisfies ChainflipChainData;

export const sepolia = {
  id: 'evm-11155111',
  name: 'Sepolia',
  addressPlaceholder: '0x...',
  wagmiChain: wagmiChains.sepolia as WagmiChain,
  chainflipId: 'Ethereum',
} satisfies ChainflipChainData;

export const backspinSolana = {
  id: 'sol-backspin',
  name: 'Backspin Solana',
  addressPlaceholder: '',
  wagmiChain: undefined,
  chainflipId: 'Solana',
} satisfies ChainflipChainData;

export const backspinEthereum = {
  id: 'evm-10997',
  name: 'Backspin',
  addressPlaceholder: '0x...',
  wagmiChain: {
    id: 10997,
    name: 'Backspin',
    network: 'backspin-ethereum',
    nativeCurrency: {
      decimals: 18,
      name: 'Backspin Ether',
      symbol: 'bsETH',
    },
    rpcUrls: {
      public: { http: ['https://eth.backspin.chainflip.io/'] },
      default: { http: ['https://eth.backspin.chainflip.io/'] },
    },
    testnet: true,
  } as WagmiChain,
  chainflipId: 'Ethereum',
} satisfies ChainflipChainData;

export const backspinArbitrum = {
  id: 'evm-412346',
  name: 'Backspin Arbitrum',
  addressPlaceholder: '0x...',
  wagmiChain: {
    id: 412346,
    name: 'Backspin Arbitrum',
    network: 'backspin-arbitrum',
    nativeCurrency: {
      decimals: 18,
      name: 'Backspin Arbitrum Ether',
      symbol: 'ArbETH',
    },
    rpcUrls: {
      public: { http: ['https://http.backspin-sequencer.staging/'] },
      default: { http: ['https://http.backspin-sequencer.staging/'] },
    },
    testnet: true,
  } as WagmiChain,
  chainflipId: 'Arbitrum',
} satisfies ChainflipChainData;

export const dotTestnet = {
  id: 'dot-testnet',
  name: 'Polkadot Testnet',
  addressPlaceholder: '1...',
  wagmiChain: undefined,
  chainflipId: 'Polkadot',
} satisfies ChainflipChainData;

export const hubTestnet = {
  id: 'hub-testnet',
  name: 'Assethub Testnet',
  addressPlaceholder: '1...',
  wagmiChain: undefined,
  chainflipId: 'Assethub',
} satisfies ChainflipChainData;

export const polygonMumbai = {
  id: 'evm-80001',
  name: 'Polygon Mumbai',
  addressPlaceholder: '0x...',
  wagmiChain: wagmiChains.polygonMumbai as WagmiChain,
} satisfies ChainData;

export const arbitrumSepolia = {
  id: 'evm-421614',
  name: 'Arbitrum Sepolia',
  addressPlaceholder: '0x...',
  wagmiChain: wagmiChains.arbitrumSepolia as WagmiChain,
  chainflipId: 'Arbitrum',
} satisfies ChainflipChainData;

export const optimismSepolia = {
  id: 'evm-420',
  name: 'Optimism Sepolia',
  addressPlaceholder: '0x...',
  wagmiChain: wagmiChains.optimismSepolia as WagmiChain,
} satisfies ChainData;

export const avalancheFuji = {
  id: 'evm-43113',
  name: 'Avalanche Fuji',
  addressPlaceholder: '0x...',
  wagmiChain: wagmiChains.avalancheFuji as WagmiChain,
} satisfies ChainData;

export const moonbaseAlpha = {
  id: 'evm-1287',
  name: 'Moonbase Alpha',
  addressPlaceholder: '0x...',
  wagmiChain: wagmiChains.moonbaseAlpha as WagmiChain,
} satisfies ChainData;

export const filecoinHyperspace = {
  id: 'evm-3141',
  name: 'Filecoin Hyperspace',
  addressPlaceholder: '0x...',
  wagmiChain: wagmiChains.filecoinHyperspace as WagmiChain,
} satisfies ChainData;

export const bscTestnet = {
  id: 'evm-97',
  name: 'Binance Smart Chain Testnet',
  addressPlaceholder: '0x...',
  wagmiChain: wagmiChains.bscTestnet as WagmiChain,
} satisfies ChainData;

export const fantomTestnet = {
  id: 'evm-4002',
  name: 'Fantom Testnet',
  addressPlaceholder: '0x...',
  wagmiChain: wagmiChains.fantomTestnet as WagmiChain,
} satisfies ChainData;

export const celoAlfajores = {
  id: 'evm-44787',
  name: 'Celo Alfajores',
  addressPlaceholder: '0x...',
  wagmiChain: wagmiChains.celoAlfajores as WagmiChain,
} satisfies ChainData;

export default [
  bitcoinTestnet,
  solanaDevnet,
  sepolia,
  backspinEthereum,
  dotTestnet,
  hubTestnet,
  polygonMumbai,
  backspinArbitrum,
  arbitrumSepolia,
  backspinSolana,
  optimismSepolia,
  avalancheFuji,
  moonbaseAlpha,
  filecoinHyperspace,
  bscTestnet,
  fantomTestnet,
  celoAlfajores,
];
